/**
 * Os bancos que dá para conectar pelo Open Finance, pelo nome.
 *
 * Cópia da lista de `backend/src/services/banco/planoDoBanco.ts`: o frontend
 * não importa do backend. `bancosAceitos.test.ts` lê o arquivo de lá e a
 * página de apresentação, e reprova se as três listas divergirem.
 */
export const BANCOS_ACEITOS = ['Nubank', 'Itaú', 'Bradesco', 'Santander', 'Banco do Brasil', 'Inter', 'C6', 'Caixa', 'BTG', 'Sicoob', 'Sicredi', 'Original'] as const;

/** "Nubank, Itaú, … e Original", para frase corrida. */
export const bancosEmFrase = (): string =>
  `${BANCOS_ACEITOS.slice(0, -1).join(', ')} e ${BANCOS_ACEITOS[BANCOS_ACEITOS.length - 1]}`;
